import MaterialTable from "material-table"
import React from "react"
import orderTableConfig from "./config"
import tableIcons from "./tableIcons"
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { Checkbox, Input, Modal } from "antd"
import "./index.css"
import { useSettlementOrdersHook } from "../../../hooks"
import Button from "../Button";
const { TextArea } = Input

export const SellersOrdersTable = ({
   sellerId,
   isAllOrderSelected = false,
   updateSettlementAmount,
   sellerOrders,
   isTransactionHistory
}) => {
   const {
      isLoading,
      isEditDataLoading,
      localization,
      actions,
      limit,
      onSelect,
      isEditPriceModalOpen,
      editPriceData,
      toggleEditPriceModal,
      handleInputChange,
      handleInputBlur,
      handleEditAmount,
      handleAllSelectToggle
   } = useSettlementOrdersHook({
      sellerId,
      updateSettlementAmount,
      sellerOrders
   })

   let columns = orderTableConfig().columns;

   if (!isTransactionHistory) {
      columns[0] = {
         ...columns[0],
         title: <Checkbox
            checked={isAllOrderSelected || false}
            onChange={(event) => { handleAllSelectToggle(event) }}
         />
         ,
         width: "20px",
         render: (rowData) => {
            return <Checkbox
               checked={rowData.isSelected || false}
               onChange={(event) => { onSelect(event, rowData) }} />
         }
      }

      columns[12] = {
         ...columns[12],
         render: rowData => {
            return <div className="edit-amount-cell">
               <b>
                  {
                     (rowData && (rowData.settlementAmount || rowData.settlementAmount === 0)
                        ? <span>&#8377;{(rowData.settlementAmount).toFixed(2)}</span>
                        : "")
                  }
               </b>
               <EditOutlinedIcon
                  color="secondary"
                  className="edit-icon"
                  fontSize="small"
                  onClick={(event) => { toggleEditPriceModal(true, rowData) }} />
            </div>
         }
      }

      columns[12] = {
         ...columns[12],
         render: rowData => {
            return <div className="edit-amount-cell">
               {
                  (rowData && rowData.settlement_description
                     ? <span>{rowData.settlement_description}</span>
                     : "")
               }
               <EditOutlinedIcon
                  color="secondary"
                  className="edit-icon"
                  fontSize="small"
                  onClick={(event) => { toggleEditPriceModal(true, rowData, true) }} />
            </div>
         }
      }
   } else {
      columns.splice(0, 1)
   }

   const filterComponent = (props) => {
      return (<div>
         <input
            type="text"
            placeholder="Search"
            style={{ fontSize: '14px', backgroundColor: "transparent" }}
            onChange={
               (e) => props.onFilterChanged(props.columnDef.tableData.id, e.target.value)
            } />
      </div>)
   };

   columns = columns.map((configItem) => {
      return {
         ...configItem,
         sorting: configItem.filterAndSearch,
         filtering: configItem.filterAndSearch,
         filterComponent: filterComponent,
         filterPlaceholder: 'Search',
         searchable: configItem.filterAndSearch || false
      }
   });

   return (
      <div className="settlement-seller-orders-wraper">
         <MaterialTable
            style={{
               width: '100%',
               boxShadow: 'none',
               background: 'white',
               padding: '15px',
               borderRadius: '5px'
            }}
            key={sellerId}
            localization={localization}
            icons={tableIcons}
            actions={actions}
            columns={columns}
            data={sellerOrders.sort((a, b) => b.order_id - a.order_id)}
            totalCount={sellerOrders.length}
            title={"Seller's Orders"}
            isLoading={(sellerOrders || []).length <= 0 ? true : isLoading}
            options={{
               toolbar: false,
               filtering: true,
               sorting: true,
               hideFilterIcons: true,
               actionsColumnIndex: 0,
               tableLayout: 'fixed',
               searchFieldAlignment: 'left',
               pageSize: limit,
               total: sellerOrders.length,
               paginationType: 'stepped',
               pageSizeOptions: [10, 20, 30, 50, 100],
               paging: true,
               search: false,
               maxBodyHeight: 'auto', // Automatically adjust body height
               rowStyle: {
                  height: "10px", // Set row height to auto
               },
               headerStyle: {
                  backgroundColor: '#f58634',
                  color: 'white',
                  padding: '8px 0 8px 16px',
               },
               filterCellStyle: {
                  backgroundColor: '#fef3ea',
                  padding: '8px 0 8px 16px',
               },
               searchFieldStyle: {
                  borderRadius: '20px',
                  border: '1px solid grey',
                  padding: '5px 35px',
                  marginBottom: '10px',
                  display: 'none',
               },
            }}
            onRowClick={(event, rowData, togglePanel) => console.log({ event, rowData, togglePanel })}
         />

         {
            !isTransactionHistory &&
            <Modal
               visible={isEditPriceModalOpen}
               closable={true}
               title="Edit Settlement Data"
               onCancel={() => toggleEditPriceModal(false)}
               footer={[
                  <Button
                     className={'ml-2'}
                     key="back"
                     label={"Close"}
                     onClick={() => toggleEditPriceModal(false)} />,
                  <Button
                     className={'ml-2'}
                     key="submit"
                     type="primary"
                     label={"Submit"}
                     onClick={() => { handleEditAmount() }} />
               ]}
            >
               <div>
                  {
                     !editPriceData.isDescriptionEdit ? (
                        <>
                           <div>
                              <label>Payable Amount : </label>
                              <b>&#8377;{editPriceData.totalAmount}</b>
                           </div>

                           <div className='mb-3'>
                              <div>New Amount : </div>
                              <Input
                                 name={"newAmount"}
                                 value={editPriceData.newAmount}
                                 placeholder="Enter a settlement number"
                                 maxLength={16}
                                 onChange={handleInputChange}
                                 onBlur={handleInputBlur}
                              />
                           </div>
                        </>
                     ) : ""
                  }

                  <div className='mb-3'>
                     <div>Settlement description</div>
                     <TextArea
                        name={"settlementDescription"}
                        value={editPriceData.settlementDescription || ""}
                        placeholder="Settlement description"
                        rows={4}
                        onChange={handleInputChange}
                     />
                  </div>
               </div>
            </Modal >
         }
      </div>

   )
}